const STRAPI_URL = (import.meta.env.VITE_STRAPI_URL || '').replace(/\/+$/, '');
const STRAPI_TOKEN = import.meta.env.VITE_STRAPI_TOKEN;

const buildUrl = (path, params) => {
  const url = new URL(`${STRAPI_URL}${path.startsWith('/') ? '' : '/'}${path}`);
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      url.searchParams.set(key, String(value));
    });
  }
  return url.toString();
};

const buildHeaders = () => {
  const headers = {
    Accept: 'application/json',
  };
  if (STRAPI_TOKEN) {
    headers.Authorization = `Bearer ${STRAPI_TOKEN}`;
  }
  return headers;
};

const requestJson = async (path, params) => {
  if (!STRAPI_URL) {
    throw new Error('Missing VITE_STRAPI_URL');
  }

  const res = await fetch(buildUrl(path, params), {
    headers: buildHeaders(),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Strapi request failed (${res.status}): ${text}`);
  }

  return res.json();
};

const mapPost = (item) => {
  const attrs = item?.attributes || {};

  const cover = attrs.cover?.data?.attributes;
  const coverUrl = cover?.url
    ? cover.url.startsWith('http')
      ? cover.url
      : `${STRAPI_URL}${cover.url}`
    : null;

  return {
    id: item?.id,
    title: attrs.title || '',
    slug: attrs.slug || '',
    excerpt: attrs.excerpt || '',
    content: attrs.content || '',
    publishedAt: attrs.publishedAt || attrs.createdAt || '',
    coverUrl,
  };
};

export const getCultPosts = async ({ pageSize = 20 } = {}) => {
  const json = await requestJson('/api/cult-posts', {
    'sort[0]': 'publishedAt:desc',
    'pagination[pageSize]': pageSize,
    'populate[0]': 'cover',
  });

  const data = Array.isArray(json?.data) ? json.data : [];
  return data.map(mapPost);
};

export const getCultPostBySlug = async (slug) => {
  const json = await requestJson('/api/cult-posts', {
    'filters[slug][$eq]': slug,
    'populate[0]': 'cover',
    'pagination[pageSize]': 1,
  });

  const first = Array.isArray(json?.data) ? json.data[0] : null;
  return first ? mapPost(first) : null;
};

export const getStrapiConfigured = () => Boolean(STRAPI_URL);
